/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LDAPServerUser,
    LDAPServerUserFromJSON,
    LDAPServerUserFromJSONTyped,
    LDAPServerUserToJSON,
} from './';

/**
 * 
 * @export
 * @interface LDAPServerUsers
 */
export interface LDAPServerUsers {
    /**
     * 
     * @type {Array<LDAPServerUser>}
     * @memberof LDAPServerUsers
     */
    users: Array<LDAPServerUser>;
}

export function LDAPServerUsersFromJSON(json: any): LDAPServerUsers {
    return LDAPServerUsersFromJSONTyped(json, false);
}

export function LDAPServerUsersFromJSONTyped(json: any, ignoreDiscriminator: boolean): LDAPServerUsers {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'users': ((json['users'] as Array<any>).map(LDAPServerUserFromJSON)),
    };
}

export function LDAPServerUsersToJSON(value?: LDAPServerUsers | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'users': ((value.users as Array<any>).map(LDAPServerUserToJSON)),
    };
}


